import { SEOItemList, SEOOrganization, SEOWebsite } from './types'

export const URL_JUSBRASIL = 'https://www.jusbrasil.com.br'

export const organization: SEOOrganization = {
  '@id': `${URL_JUSBRASIL}/#organization`,
  '@type': 'Organization',
  name: 'Jusbrasil',
  description:
    // eslint-disable-next-line max-len
    'Acesse o Jusbrasil para Consulta Processual nos Tribunais, Pesquisa de Jurisprudência, Legislação, Doutrina, Modelos, Peças Processuais Jurídicas e mais para facilitar pesquisas e acompanhar processos. Através da plataforma disponibilizamos informação jurídica gratuita para pessoas e profissionais do Direito, além de ser a maior comunidade de advogados cadastrados que interagem na comunidade e podem ser contatados para auxiliar nos diversos casos das diferentes esferas.',
  url: URL_JUSBRASIL,
  alternateName: 'Jus',
  logo: 'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-1200.png',
  sameAs: [
    'https://www.facebook.com/Jusbrasil/',
    'https://twitter.com/jusbrasil',
    'https://www.instagram.com/jusbrasil/',
    'https://www.youtube.com/jusbrasil',
    'https://www.linkedin.com/company/jusbrasil/',
    'https://www.jusbrasil.com.br',
  ],
}

export const siteNavigation: SEOItemList = {
  '@id': `${URL_JUSBRASIL}/#navigation`,
  '@type': 'ItemList',
  itemListElement: [
    {
      '@type': 'SiteNavigationElement',
      name: 'Home',
      url: URL_JUSBRASIL,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Consulta Processual',
      url: `${URL_JUSBRASIL}/consulta-processual/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Jurisprudência',
      url: `${URL_JUSBRASIL}/jurisprudencia/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Doutrina',
      url: `${URL_JUSBRASIL}/doutrina/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Artigos',
      url: `${URL_JUSBRASIL}/artigos/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Notícias',
      url: `${URL_JUSBRASIL}/noticias/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Diários Oficiais',
      url: `${URL_JUSBRASIL}/diarios/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Peças Processuais',
      url: `${URL_JUSBRASIL}/pecas/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Modelos',
      url: `${URL_JUSBRASIL}/modelos-pecas/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Legislação',
      url: `${URL_JUSBRASIL}/legislacao/`,
    },
    {
      '@type': 'SiteNavigationElement',
      name: 'Advogados',
      url: `${URL_JUSBRASIL}/advogados/`,
    },
  ],
}

export const website: SEOWebsite = {
  '@type': 'WebSite',
  '@id': `${URL_JUSBRASIL}/#website`,
  name: 'Jusbrasil',
  description:
    'Pesquisa jurídica completa com processos, jurisprudência, legislação e conteúdos especializados.',
  publisher: {
    '@id': `${URL_JUSBRASIL}/#organization`,
  },
  url: URL_JUSBRASIL,
  potentialAction: {
    '@id': `${URL_JUSBRASIL}/#search-action`,
    '@type': 'SearchAction',
    name: 'Jusbrasil',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${URL_JUSBRASIL}/busca?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
  hasPart: {
    '@id': `${URL_JUSBRASIL}/#navigation`,
  },
}
